import type { GenerationType } from '@/api/types';

export interface PromptSuggestion {
  label: string;
  text: string;
}

const VIDEO_SUGGESTIONS: PromptSuggestion[] = [
  { label: 'Кинематограф', text: 'cinematic shot, shallow depth of field, soft natural light' },
  { label: 'Slow motion', text: 'slow motion, smooth dreamy movement' },
  { label: 'Золотой час', text: 'golden hour lighting, warm sunset glow' },
  { label: 'Динамичная камера', text: 'dynamic camera movement, dolly-in, subtle handheld' },
  { label: 'Студийный свет', text: 'studio lighting, clean backdrop, sharp focus on subject' },
];

const IMAGE_SUGGESTIONS: PromptSuggestion[] = [
  { label: 'Портрет', text: 'editorial portrait, soft window light, 85mm lens, natural skin tones' },
  { label: 'Минимализм', text: 'minimalist composition, neutral palette, plenty of negative space' },
  { label: 'Киноплёнка', text: 'film photo aesthetic, gentle grain, warm color grading' },
  { label: 'Постер', text: 'bold magazine-cover composition, strong typography-friendly framing' },
  { label: 'Студия', text: 'studio shot, soft beauty light, seamless backdrop' },
];

export function promptSuggestionsFor(kind: GenerationType): PromptSuggestion[] {
  return kind === 'image' ? IMAGE_SUGGESTIONS : VIDEO_SUGGESTIONS;
}

export function appendSuggestion(current: string, suggestion: string): string {
  const trimmed = current.trim();
  if (!trimmed) return suggestion;
  if (trimmed.toLowerCase().includes(suggestion.toLowerCase())) return current;
  const sep = /[.,!?]$/.test(trimmed) ? ' ' : ', ';
  return `${trimmed}${sep}${suggestion}`;
}
